"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { PropsWithChildren } from "react";

type Props = {
  path: string;
  isActivePaths?: string[];
  className?: string;
  disableHover?: boolean;
};

const LinkItem: React.FC<PropsWithChildren<Props>> = ({
  path,
  isActivePaths,
  className,
  disableHover,
  children,
}) => {
  const currentPath = usePathname();

  const isActive = isActivePaths
    ? isActivePaths.map((path) => currentPath.startsWith(path)).includes(true)
    : path === "/hotel/search"
      ? currentPath === "/hotel/search" ||
        (currentPath.startsWith("/hotel/search/") &&
          !currentPath.startsWith("/hotel/search/researcher"))
      : currentPath.startsWith(path);

  return (
    <Link
      href={path}
      className={cn(
        "flex items-center justify-center gap-2.5 rounded-full p-3 text-lg font-normal leading-none transition-colors",
        "bg-foreground/0",
        isActive ? "text-primary" : "text-muted-foreground",
        !disableHover && "hover:bg-foreground/10 hover:text-foreground",
        className
      )}
    >
      {children}
    </Link>
  );
};

export default LinkItem;
